export default __webpack_public_path__ + "static/media/spark_33.17bf698d.png";